<template>
  <el-dialog
    v-model="dialogShow"
    title="选择品牌"
    width="500px"
    :close-on-click-modal="true"
    :show-close="false"
    destroy-on-close
    @close="handleBack"
  >
    <div class="dialo-content">
      <el-form ref="form">
        <el-form-item style="width: 200px">
          <!-- <el-input
            v-model="dialogSearchInp"
            placeholder="搜索品牌"
            :suffix-icon="Search"
            @change="handleSearchCompany"
          ></el-input> -->
          <el-input
            v-model="dialogSearchInp"
            placeholder="搜索品牌"
            class="input-with-select"
          >
            <template #append>
              <el-button :icon="Search" @click="handleSearchCompany"></el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <el-table :data="dialogTable" border max-height="300">
        <el-table-column prop="name" label="品牌名称" />
        <!-- <el-table-column prop="type" label="所属领域" /> -->
        <el-table-column label="所属领域">
          <template #default="scope">
            <div v-for="item in scope.row.trade_names">{{item}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-radio v-model="dialogRadio" :label="scope.row.id" @change="()=> handleRadioChange(scope.row.id)"
              >选择</el-radio
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="table-pagination-row mg-t-24">
        <el-pagination
          background
          :currentPage="dialogPaginationData.current"
          :page-sizes="dialogPaginationData.pageSizes"
          :page-size="dialogPaginationData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="dialogPaginationData.total"
          @size-change="dialogHandleSizeChange"
          @current-change="dialogHandleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <template #footer>
      <el-button plain @click="handleBack">返回</el-button>
      <el-button type="primary" @click="handleAddCompany">完成</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { computed, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Plus, Search } from "@element-plus/icons-vue";
import { Ajax, MessageTips } from "@/utils";
export default {
  components: {
    Plus,
  },
  props: {
    isShowAddCompany: Boolean,
    companyId: String
  },

  setup(props, {emit}) {
    const route = useRoute();
    const router = useRouter();
    /* 弹窗选择 start */
    const dialogShow = ref(props.isShowAddCompany);
    const dialogSearchInpRef = ref("");
    const dialogTable = ref([]);
    const dialogRadioRef = ref("");
    const dialogPaginationData = ref({
      current: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50],
      total: 0,
    });
    const object_id = ref('')
    const companyId = ref(props.companyId)
    onMounted(() => {
      // handleSearchCompany();
    });

    // 搜索品牌
    const handleSearchCompany = async () => {
      let page = dialogPaginationData.value.current;
      let size = dialogPaginationData.value.pageSize;
      const res = await Ajax.POST({
        url: "/admin/brand/search",
        data: {
          name: dialogSearchInpRef.value,
          page,
          size,
        },
      });
      if (res.data.code == 200) {
        dialogPaginationData.value.total = res.data.data.total;
        dialogTable.value = res.data.data
      }
    };

    // 添加品牌
    const handleAddCompany = async (e) => {
      const res = await Ajax.POST({
        url: `/admin/album/company/create/${companyId.value}`,
        data: {
          object_id: object_id.value,
        },
      });
      console.log('res', res)
      if (res.data.code === 200){
        emit('closeDialog')
      } else {
        MessageTips.error(res.data.msg)
      }
    };

    const dialogHandleSizeChange = (e) => {
      dialogPaginationData.value.pageSize = e;
      dialogPaginationData.value.current = 1
      handleSearchCompany()
    };
    const dialogHandleCurrentChange = (e) => {
      dialogPaginationData.value.current = e;
      handleSearchCompany()
    };
    const handleBack = () => {
      dialogShow.value = false;
      emit('closeDialog')
    };
    /* 弹窗选择 end */
    const handleRadioChange = id => {
      object_id.value = id
    }
    return {
      // 弹窗
      dialogShow,
      dialogSearchInp: dialogSearchInpRef,
      dialogTable,
      dialogRadio: dialogRadioRef,
      dialogPaginationData,
      dialogHandleSizeChange,
      dialogHandleCurrentChange,
      handleBack,
      handleSearchCompany,
      Search,
      handleRadioChange,
      object_id,
      handleAddCompany,
      companyId
    };
  },
};
</script>

<style lang="less" scoped></style>
